export function loadDropDowns() {
  // lista de dropDowns da página
  const dropDownBtnList = document.querySelectorAll('.js-dropDown')

  // para cada dropDown
  dropDownBtnList.forEach((dropDownBtn) => {
    // dropDown resultados
    const dropDownResults = dropDownBtn?.nextElementSibling

    // click apenas no dropDown
    dropDownBtn.addEventListener('click', () => {
      dropDownBtn.classList.toggle('drop-down--open')
      dropDownResults?.classList.toggle('drop-down__results--show')
    })

    // click em algum item do dropDown
    for (let child of dropDownResults.children[0].children) {
      child.addEventListener('click', () => {
        // substitui texto do dropDown pelo item selecionado
        dropDownBtn.children[0].innerText =
          child.innerText || dropDownBtn.innerText
        dropDownResults.classList.toggle('drop-down__results--show')
        dropDownBtn.classList.toggle('drop-down--open')
      })
    }
  })
}
